<template>
  <div class="rebase">
    <Header
      v-bind:pageName="pageName"
      v-bind:login="login"
      v-bind:profile="profile"
      @profile="profile = $event"
      v-bind:mai="mai"
      @mai="mai = $event"
    />
    <Loading v-if="loading" />
    <div v-else class="rebase_wrapper">
      <section class="name_wrapper">
        <h2>チャレンジ名</h2>
        <div class="name">
          <label
            ><input type="text" v-model="setting.name" /><span
              >{{ setting.name.length }}/50</span
            ></label
          >
        </div>
      </section>
      <section class="params_wrapper">
        <h2>チャレンジ設定</h2>
        <div class="params">
          <div class="setting">
            <div class="span-tab">
              <p class="title">目標期間 ・目標ペース |</p>
              <ul>
                <li>
                  <label class="radio">
                    <input
                      type="radio"
                      value="span"
                      v-model="setting.span_tab"
                    />
                    <span>期間</span>
                  </label>
                  <div v-if="setting.span_tab == 'span'" class="span">
                    <label class="radio"
                      ><input
                        type="radio"
                        name="span"
                        :value="new Date().setDate(new Date().getDate() + 7)"
                        v-model="setting.span.span"
                      /><span>1週間</span></label
                    >
                    <label class="radio"
                      ><input
                        type="radio"
                        name="span"
                        :value="new Date().setMonth(new Date().getMonth() + 1)"
                        v-model="setting.span.span"
                      /><span>1ヶ月間</span></label
                    >
                    <label class="radio"
                      ><input
                        type="radio"
                        name="span"
                        :value="new Date().setMonth(new Date().getMonth() + 3)"
                        v-model="setting.span.span"
                      /><span>3ヶ月間</span></label
                    >
                    <label class="radio"
                      ><input
                        type="radio"
                        name="span"
                        :value="new Date().setMonth(new Date().getMonth() + 6)"
                        v-model="setting.span.span"
                      /><span>6ヶ月間</span></label
                    >
                    <label class="radio"
                      ><input
                        type="radio"
                        name="span"
                        :value="
                          new Date().setFullYear(new Date().getFullYear() + 1)
                        "
                        v-model="setting.span.span"
                      /><span>1年間</span></label
                    >
                    <p class="or">または</p>
                    <div class="date">
                      <select
                        name="year"
                        id="year"
                        :value="span_select.picked.year"
                        @change="
                          setting.span.span = 'select';
                          select_check_year($event);
                        "
                      >
                        <option
                          v-for="item in span_select.year"
                          :key="span_select.year[item]"
                          :value="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        name="month"
                        id="month"
                        :value="span_select.picked.month"
                        @change="
                          setting.span.span = 'select';
                          select_check($event);
                        "
                      >
                        <option
                          v-for="item in span_select.month"
                          :key="span_select.month[item]"
                          :value="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        name="day"
                        id="day"
                        :value="span_select.picked.day"
                        @change="
                          setting.span.span = 'select';
                          select_check_day($event);
                        "
                      >
                        <option
                          v-for="item in span_select.day"
                          :key="span_select.day[item]"
                          :value="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span>まで</span>
                    </div>
                  </div>
                </li>
                <li>
                  <label class="radio">
                    <input
                      type="radio"
                      value="per"
                      v-model="setting.span_tab"
                    />
                    <span>ペース</span>
                  </label>
                  <div v-if="setting.span_tab == 'per'" class="span_per">
                    <div class="per_wrapper">
                      <label class="number">
                        <input
                          type="number"
                          v-model="setting.span.per.sheets"
                          @input="per_check('sheet')"
                        />
                        <span>枚<span style="font-size: 24px">/</span></span>
                      </label>
                      <button
                        class="minus"
                        @click="increment('sheet', 'minus')"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                      <button class="plus" @click="increment('sheet', 'plus')">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                    <div class="per_wrapper">
                      <label class="number">
                        <input
                          type="number"
                          v-model="setting.span.per.days"
                          @input="per_check('day')"
                        />
                        <span>日</span>
                      </label>
                      <button class="minus" @click="increment('day', 'minus')">
                        <i class="fas fa-minus"></i>
                      </button>
                      <button class="plus" @click="increment('day', 'plus')">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </li>
                <li>
                  <label class="radio">
                    <input
                      type="radio"
                      value="none"
                      v-model="setting.span_tab"
                    />
                    <span>設定しない</span>
                  </label>
                  <div v-if="setting.span_tab == 'none'"></div>
                </li>
              </ul>
            </div>
            <div class="goal">
              <p class="title">目標枚数 |</p>
              <label class="number">
                <input
                  type="number"
                  v-model="setting.goal"
                  @input="check_goal($event)"
                />
                <span>枚</span>
              </label>
            </div>
            <div class="public">
              <!-- iconを入れる -->
              <p class="title">公開設定 |</p>
              <div>
                <label class="radio"
                  ><input
                    type="radio"
                    name="public"
                    value="public"
                    v-model="setting.public"
                  /><span>公開</span></label
                >
                <label class="radio"
                  ><input
                    type="radio"
                    name="public"
                    value="private"
                    v-model="setting.public"
                  /><span>非公開</span></label
                >
              </div>
            </div>
          </div>
          <div class="graph">
            <div class="item">
              <p class="item_title">{{ setting.name }}</p>
              <div class="item_div">
                <div class="item_graph">
                  <div class="graph_img" style="transform: rotate(-90deg)">
                    <svg
                      height="100%"
                      viewBox="0 0 20 20"
                      width="100%"
                      style="overflow: visible"
                    >
                      <circle
                        cx="50%"
                        cy="50%"
                        fill="none"
                        stroke-width="1"
                        r="9"
                        stroke="#E6EAE6"
                      />
                      <circle
                        cx="50%"
                        cy="50%"
                        fill="none"
                        stroke-width="1"
                        r="9"
                        stroke="#F18D5F"
                        stroke-linecap="round"
                        style="stroke-dashoffset: 56; stroke-dasharray: 56.5487"
                      />
                    </svg>
                  </div>
                  <p class="graph_percentage"><span>0</span>%</p>
                  <div class="graph_detail">
                    <p>目標ペース</p>
                    <p class="fraction">
                      <span>{{ graph_mai() }}</span
                      >枚/<span>{{ graph_day() }}</span
                      >日
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button class="create" @click="create()">始める</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import firebaseUtil from "@/firebase";
import store from "@/store";

import Header from "@/components/modules/header";
import Loading from "@/components/parts/Loading";

export default {
  components: {
    Header,
    Loading,
  },
  data() {
    return {
      pageName: "ホーム",
      login: false,
      user: {},
      provider: {},
      profile: {},
      mai: {},
      loading: true,
      span_select: {
        year: [new Date().getFullYear(), new Date().getFullYear() + 1],
        month: [...Array(12).keys()].map((i) => ++i),
        day: [...Array(31).keys()].map((i) => ++i),
        picked: {
          year: Number(new Date().getFullYear()),
          month: Number(new Date().getMonth() + 1),
          day: "",
        },
      },
      setting: {
        name: "新たな挑戦",
        span_tab: "span",
        span: {
          span: "week_1",
          per: {
            sheets: 1,
            days: 1,
          },
        },
        goal: 100,
        public: "private",
      },
    };
  },
  created() {
    let myPromise1 = new Promise((resolve) => {
      firebaseUtil.onAuth("none").then(() => {
        resolve();
      });
    });
    myPromise1.then(() => {
      this.user = store.getters.user;
      console.log(this.user);
      if (!this.user.state) {
        this.user = "";
        location.replace("/ranking");
      } else {
        for (let i = 0; i < this.user.providerData.length; i++) {
          if (this.user.providerData[i].providerId == "twitter.com") {
            this.provider.twitter = true;
          } else {
            this.provider.google = true;
          }
        }
        this.login = true;
        this.loading = false;
      }
    });
    const isLeapYear = (year) =>
      (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    const datesOfFebruary = isLeapYear(this.span_select.picked.year) ? 29 : 28;
    const datesOfYear = [
      31,
      datesOfFebruary,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];
    let now_month = Number(new Date().getMonth() + 1);
    let now_day = Number(new Date().getDate());
    let start = Number(now_day + 3);
    if (start > datesOfYear[Number(now_month) - 1]) {
      let diff = start - datesOfYear[Number(now_month) - 1];
      start = diff; //はみ出た日付
      now_month = now_month + 1; //次の月
    }
    this.span_select.picked.day = start;
    this.span_select.picked.month = now_month;
  },
  watch: {
    // listもしくはlist内のプロパティに変更があった場合に処理が実行される
    setting: {
      handler() {
        // this.check_span();
      },
      // deepがfalseだとオブジェクト内の値が変更されても処理が実行されない
      deep: true,
      immediate: true,
    },
  },
  methods: {
    graph_mai() {
      if (this.setting.span_tab == "span") {
        // 期間
        if (this.setting.span.span == "select") {
          this.setting.span.span = new Date(
            this.span_select.picked.year,
            this.span_select.picked.month - 1,
            this.span_select.picked.day
          );
        }
        let diff =
          new Date(this.setting.span.span).getTime() - new Date().getTime();
        let between = this.setting.goal / (diff / 86400000);
        let arr = Array.from(between.toString());
        arr.splice(arr.indexOf("."), 1);
        let zero = ["1"];
        arr.some((item) => {
          if (item != "0") {
            return true;
          }
          zero.push("0");
        });
        let sum = between * Number(zero.join(""));
        return sum.toFixed(1);
      } else if (this.setting.span_tab == "per") {
        // ペース
        return this.setting.span.per.sheets;
      }
    },
    graph_day() {
      if (this.setting.span_tab == "span") {
        let diff =
          new Date(this.setting.span.span).getTime() - new Date().getTime();
        let between = this.setting.goal / (diff / 86400000);
        let arr = Array.from(between.toString());
        arr.splice(arr.indexOf("."), 1);
        let zero = ["1"];
        arr.some((item) => {
          if (item != "0") {
            return true;
          }
          zero.push("0");
        });
        return Number(zero.join(""));
      } else if (this.setting.span_tab == "per") {
        // ペース
        return this.setting.span.per.days;
      }
    },
    getMaxDay(month) {
      const isLeapYear = (year) =>
        (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
      const datesOfFebruary = isLeapYear(this.span_select.picked.year)
        ? 29
        : 28;
      const datesOfYear = [
        31,
        datesOfFebruary,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];
      return datesOfYear[Number(month) - 1];
    },
    select_check_year(event) {
      this.span_select.picked.year = event.target.value;
      let now_month = Number(new Date().getMonth() + 1);
      let now_day = Number(new Date().getDate() + 3);
      if (this.span_select.picked.year != new Date().getFullYear()) {
        //来年
        let max = now_month;
        this.span_select.month = [...Array(max).keys()].map((i) => ++i);
        this.span_select.day = [...Array(this.getMaxDay(now_month)).keys()].map(
          (i) => ++i
        );
      } else {
        //今年
        if (now_day >= this.getMaxDay(now_month)) {
          now_month = now_month + 1; //次の月
        }
        let max = 12;
        let start = now_month;
        this.span_select.month = [...Array(max - start + 1).keys()].map(
          (e) => e + start
        );
        this.span_select.day = [...Array(this.getMaxDay(now_month)).keys()].map(
          (i) => ++i
        );
      }
      this.span_select.picked.month = 1;
      this.span_select.picked.day = 1;
    },
    select_check_day(event) {
      this.span_select.picked.day = event.target.value;
    },
    select_check(event) {
      let now_month = Number(new Date().getMonth() + 1);
      let now_day = Number(new Date().getDate());
      if (this.span_select.picked.year != new Date().getFullYear()) {
        //来年
        if (event.target.value > now_month) {
          //今月よりも大きい
          let max =
            this.getMaxDay(now_month) - now_day >= 1
              ? now_day
              : this.getMaxDay(now_month);
          //月のmaxと今日で小さい方をmaxにする
          this.span_select.day = [...Array(max).keys()].map((i) => ++i);
          this.span_select.picked.month = now_month;
          //今月にする
        } else {
          let max = this.getMaxDay(event.target.value);
          this.span_select.day = [...Array(max).keys()].map((i) => ++i);
          this.span_select.picked.month = event.target.value;
        }
      } else {
        //今年
        if (event.target.value < now_month) {
          //今月よりも小さい
          let start = now_day + 3;
          if (start >= this.getMaxDay(now_month)) {
            let diff = start - this.getMaxDay(now_month);
            start = diff; //はみ出た日付
            now_month = now_month + 1; //次の月
          }
          let max = this.getMaxDay(now_month);
          this.span_select.day = [...Array(max - start + 1).keys()].map(
            (e) => e + start
          );
          this.span_select.picked.month = now_month;
        } else {
          let max = this.getMaxDay(event.target.value);
          this.span_select.day = [...Array(max).keys()].map((i) => ++i);
          this.span_select.picked.month = event.target.value;
        }
      }
      this.span_select.picked.day = 1;
    },
    per_check(name) {
      // 0以上の整数のみ
      function isNumber(val) {
        var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
        return regexp.test(val);
      }
      if (name == "sheet") {
        if (
          !isNumber(
            this.setting.span.per.sheets || this.setting.span.per.sheets <= 1
          )
        ) {
          this.setting.span.per.sheets = 1;
        } else if (this.setting.span.per.sheets >= 100) {
          this.setting.span.per.sheets = 100;
        }
      } else {
        if (
          !isNumber(
            this.setting.span.per.days || this.setting.span.per.days <= 1
          )
        ) {
          this.setting.span.per.days = 1;
        } else if (this.setting.span.per.days >= 365) {
          this.setting.span.per.days = 365;
        }
      }
    },
    increment(name, option) {
      if (name == "sheet") {
        if (option == "plus") {
          if (this.setting.span.per.sheets >= 100) {
            return;
          }
          this.setting.span.per.sheets++;
        } else {
          if (this.setting.span.per.sheets <= 1) {
            return;
          }
          this.setting.span.per.sheets--;
        }
      } else {
        if (option == "plus") {
          if (this.setting.span.per.days >= 365) {
            return;
          }
          this.setting.span.per.days++;
        } else {
          if (this.setting.span.per.days <= 1) {
            return;
          }
          this.setting.span.per.days--;
        }
      }
    },
    check_goal(event) {
      function isNumber(val) {
        var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
        return regexp.test(val);
      }
      if (event.target.value >= 100) {
        this.setting.goal = 100;
      } else if (!isNumber(event.target.value) || event.target.value <= 1) {
        this.setting.goal = 1;
      }
    },
    create() {
      firebaseUtil.setChallenge(this.user.uid, this.setting).then((cid) => {
        this.$router.push({ name: "Challenge", params: { cid: cid } });
      });
    },
  },
};
</script>

<style lang="scss">
.rebase {
  section {
    h2 {
      @include fz(28);
      margin: 60px auto 40px;
    }
  }
  .name {
    label {
      height: 40px;
      @include fz(18);
      position: relative;
      input {
        background-color: #fff;
        width: 240px;
        margin-right: 10px;
        border-radius: 4px;
        border: 1px solid #000;
        padding: 4px 10px;
      }
    }
    span {
      position: absolute;
      top: calc(50% - 13px);
    }
  }
  .params {
    padding: 0 4.6vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    .graph {
      .item {
        width: 246px;
        padding: 20px;
        &_title {
          text-align: center;
          @include fz(16);
          @include text_overflow(2);
        }
        &_div {
          text-align: center;
          @include challenge_graph(160px, 24, 18);
          margin: 20px auto;
        }
        .graph_img {
          height: 100%;
          width: 100%;
          left: 0;
          top: 0;
        }
      }
    }
    .setting {
      padding: 20px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: $btn_shadow;
      .title {
        margin-bottom: 10px;
      }
      .span-tab,
      .goal,
      .public {
        margin-bottom: 40px;
        label.radio {
          cursor: pointer;
          @include fz(18);
          font-weight: 300;
          border-radius: 4px;
          padding: 10px;
          transition: 0.3s;
          display: flex;
          align-items: center;
          span {
            margin-left: 10px;
          }
          @include pc {
            &:hover {
              background-color: $bg_accent;
              input {
                transform: scale(1.2);
              }
            }
          }
          input {
            height: 24px;
            width: 24px;
            &:checked {
              & + span {
                font-weight: 500;
                color: $main_orange;
              }
            }
          }
        }
        label.number {
          @include fz(18);
          padding: 10px 0;
          input {
            padding: 4px;
            text-align: right;
            width: 80px;
            border-radius: 4px;
            border: 1px solid $text_gray;
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
              -webkit-appearance: none !important;
              margin: 0 !important;
              -moz-appearance: textfield !important;
            }
          }
          span {
            margin-left: 10px;
            font-weight: 300;
          }
        }
      }
      .span {
        margin-left: 20px;
        padding: 10px;
        padding-left: 20px;
        border-left: 1px solid $main_orange;
        label.radio {
          @include fz(16);
          span {
            margin-left: 10px;
          }
          @include pc {
            &:hover {
              background-color: $bg_accent;
              input {
                transform: scale(1.2);
              }
            }
          }
          input {
            height: 20px;
            width: 20px;
          }
        }
        .or {
          margin: 10px 0;
          @include fz(16);
        }
        .date {
          @include fz(16);
          margin: 10px 0;
          select {
            height: 40px;
            padding: 0 10px;
            margin-right: 4px;
            border-radius: 4px;
            border: 1px solid $text_gray;
            text-align: right;
          }
          span {
            font-weight: 300;
          }
        }
      }
      .span_per {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 20px;
        padding: 20px 0 20px 20px;
        border-left: 1px solid $main_orange;
        .per_wrapper {
          display: grid;
          grid-template-columns: 1fr 40px 40px;
          align-items: center;
          column-gap: 10px;
        }
        button {
          i {
            @include fz(16);
          }
          height: 40px;
          width: 40px;
          @include flex_c();
          border-radius: 4px;
          &.minus {
            background-color: $bg_accent;
          }
          &.plus {
            background-color: $main_orange;
          }
          &:active {
            filter: brightness(1.2);
          }
        }
      }
      .goal {
        li {
          padding: 10px;
          padding-left: 0;
        }
        label.number {
          padding: 0 10px;
          input {
            width: auto;
          }
        }
      }
    }
  }
  .create {
    margin-top: 40px;
    @include round_btn(#fff, $main_orange, "true");
    border-radius: 4px;
    transition: 0.3s;
    @include pc {
      &:hover {
        background-color: $main_orange;
        color: #fff;
      }
    }
  }
}
</style>
